import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

/**
 * This service is used to inform components, that the user is logged out - so that cleanup can be done.
 * (This is a workaround, since a direct subscription to the authFacadeService or the store will create a circular dependency.
 * 
 * WARNING in Circular dependency detected:
projects\jml-lib\src\lib\modules\app-menu\index.ts -> 
projects\jml-lib\src\lib\modules\app-menu\services\dynamic-routes.service.ts -> 
projects\jml-lib\src\lib\modules\dto\components\entity-view\entity-view.component.ts -> 
projects\jml-lib\src\lib\modules\entity-store-access\index.ts -> 
projects\jml-lib\src\lib\modules\entity-store-access\services\stored-entity-state.service.ts -> 
projects\jml-lib\src\lib\root-store\root-index.ts -> 
projects\jml-lib\src\lib\root-store\root-store.module.ts -> 
projects\jml-lib\src\lib\root-store\user-profile-store\user-profile-store.module.ts -> 
projects\jml-lib\src\lib\root-store\user-profile-store\user-profile.effects.ts -> 
projects\jml-lib\src\lib\modules\app-menu\index.ts
 * 
 * )
 * A solution without this extra service would be desirable.
 *
 * @export
 * @class AuthEventService
 */
@Injectable({
  providedIn: 'root'
})
export class AuthEventService {
  private $logout: Subject<void> = new Subject<void>()
  logoutEvent$ = this.$logout.asObservable()

  constructor() {}

  userIsLoggingOut() {
    this.$logout.next()
  }
}
